function strip_tags(string) {
  return string.replace(/(<([^>]+)>)/g, '');
}
function iOS() {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

let isAuto = window.location.host.match('auto.co.zw') != null ? true : false;

function loadButtonModalClick() {
  $('.btn-modal')
    .on('click', function (e) {
      e.preventDefault();
      var $target = $($(this).data('target') || $(this).attr('href'));
      $target.data('clicked', this).modal('show');
    })
    .css({
      opacity: 0,
    })
    .css({
      visibility: 'visible',
    })
    .animate(
      {
        opacity: 1,
      },
      1500
    );

  $('.modal').modal({
    show: false,
  });
}

jQuery(function () {
  var advert;
  var model;

  $('#pay-per-view-form').submit(function (e) {
    e.preventDefault();

    $('#pay-per-view-form').css('pointer-events', 'all');

    var postData = $(this).serializeArray();
    var formURL = $(this).find('input[name="formAction"]').val();
    var pageURL = $(this).find('input[name="currentUrl"]').val();

    $.ajax({
      url: formURL,
      type: 'POST',
      data: postData,
    })
      .done(function (paymentResponse) {
        $.ajax({
          url: pageURL,
        }).done(function (viewResponse) {
          if (
            viewResponse.data != undefined &&
            viewResponse.data.view === 'advert'
          ) {
            $('.listing').html(viewResponse.data.inject);
          }
        });

        if (
          paymentResponse.data != undefined &&
          paymentResponse.data.code === 200 &&
          typeof paymentResponse === 'object'
        ) {
          // use paid advert data for the pop modal after payment
          var paidAdvert = paymentResponse.data.advert;

          var listing = '#listing-' + paidAdvert.id;
          if ($(listing).data('view') === paymentResponse.data.view) {
            $(listing).replaceWith(paymentResponse.data.inject);
          }

          advert = paidAdvert;

          $('.modal-footer').css('pointer-events', 'all');
          $('#contact-seller').css('pointer-events', 'all');

          clearModal($('#contact-seller'));

          setTimeout(function () {
            $('#contact-seller').modal('show');
            $('#closePayToView').click();
          }, 500);

          setTimeout(function () {
            $('.modal-alerts')
              .html(
                '<div class="alert alert-success alert-dismissable">' +
                  paymentResponse.data.message +
                  '<b/>' +
                  '</div>'
              )
              .fadeIn('slow');
          }, 1000);

          return true;
        } else if (
          paymentResponse.data != undefined &&
          (paymentResponse.data.code === 402 ||
            paymentResponse.data.code === 302) &&
          typeof paymentResponse === 'object'
        ) {
          window.location.replace(paymentResponse.data.redirect);
          return false;
        }
      })
      .fail(function (response) {
        if (
          response !== undefined &&
          response.status === 500 &&
          typeof response === 'object'
        ) {
          $('body').css('pointer-events', 'all');
          $('.modal-pay-per-view-title').empty();
          $('.modal-pay-per-view-title').append(
            '<div class="alert alert-danger alert-dismissable"> <b>' +
              '<p>Server error, our developers have been notified and are rectifying the issue. </p>' +
              '</b></div>'
          );
        } else if (
          response.data != undefined &&
          response.data.code === 302 &&
          typeof response === 'object'
        ) {
          $('.alerts').empty();
          $('.alerts').append(
            '<div class="alert alert-warning alert-dismissable"> <b>' +
              '<p>The advert you want to pay for, doesn’t exist anymore.</p>' +
              '</b></div>'
          );
          window.location.replace(response.data.redirect);
        } else {
          $('body').css('pointer-events', 'all');
          $('#pay-per-view-form-submit').hide();
          $('.modal-pay-per-view-title').empty();
          $('.modal-pay-per-view-title').append(
            '<div class="alert alert-danger alert-dismissable"> <b>' +
              response.data.message +
              '</b></div>'
          );
        }
      });
  });

  $('#register-phonenumber-form').submit(function (e) {
    e.preventDefault();
    var postData = $(this).serializeArray();

    var formURL = $(this).find('input[name="formAction"]').val();

    $.ajax({
      url: formURL,
      type: 'POST',
      data: postData,
    })
      .done(function (response) {
        if (
          response.data != undefined &&
          response.data.code === 200 &&
          typeof response === 'object'
        ) {
          setTimeout(function () {
            $('#contact-seller').modal('show');
            $('#register-phonenumber').modal('hide');
          }, 500);
        } else {
          $('.modal-register-phonenumber-title').empty();
          $('.modal-register-phonenumber-title').append(
            '<div class="alert alert-danger alert-dismissable"> <b>' +
              response.data.message +
              '</b></div>'
          );
        }
      })
      .fail(function (response) {
        var message = '';

        if (
          response.responseJSON.data.message.mobile_number_country !== undefined
        ) {
          message +=
            response.responseJSON.data.message.mobile_number_country[0] +
            '<br>';
        }

        if (response.responseJSON.data.message.mobile_number !== undefined) {
          message +=
            response.responseJSON.data.message.mobile_number[0] + '<br>';
        }

        $('.modal-register-phonenumber-title').empty();
        $('.modal-register-phonenumber-title').append(
          '<div class="alert alert-danger alert-dismissable"><p>' +
            message +
            '</p></div>'
        );
      });
  });

  var $mapCanvas = $('#contact-seller .map-canvas');

  loadButtonModalClick();

  $('.modal').on('show.bs.modal', function (e) {
    var $modal = $(this);
    clearModal($modal);

    if ($modal.attr('id') === 'contact-seller') {
      $modal
        .find('#main .modal-title')
        .html(
          '<div>Loading Contact Details</div><div class="lds-ripple"><div></div><div></div></div>'
        );
    }

    var button = $modal.data('clicked');
    var category = $(button)
      .closest('.listing, .listing-related')
      .data('category');

    if (category !== undefined) {
      if (category['level_1'] !== undefined && category['level_1'] === 161) {
        $('.login-disclaimer').empty();
        $('.login-disclaimer').append(jsTrans['login_not_share_disclaimer']);
      } else {
        $('.login-disclaimer').empty();
        $('.login-disclaimer').append(jsTrans['login_share_disclaimer']);
      }
    } else {
      $('.login-disclaimer').empty();
      $('.login-disclaimer').append(jsTrans['login_share_disclaimer']);
    }

    var $mainDetails = $modal.find('#main .details');

    var id = $(button).closest('.listing, .listing-related').data('id');
    var type = $(button).closest('.listing, .listing-related').data('type');
    var intent = $(button).data('intent');

    // This removes the selected data from jquery cache, we always want fresh data
    $(button).removeData();

    if (!id || !type || !intent) {
      var payPerViewForm = $('#pay-per-view-form');
      var registerPhoneNumberForm = $('#register-phonenumber-form');

      if (payPerViewForm.find('#pay_advert_id').val() !== '') {
        id = payPerViewForm.find('#pay_advert_id').val();
        intent = payPerViewForm.find('#intent').val();
        type = payPerViewForm.find('#pay-per-view-form-submit').data('type');

        // This removes the selected data from jquery cache, we always want fresh data
        payPerViewForm.find('#pay-per-view-form-submit').removeData();
      } else if (registerPhoneNumberForm.find('#advert_id').val() !== '') {
        id = registerPhoneNumberForm.find('#advert_id').val();
        intent = registerPhoneNumberForm.find('#intent').val();
        type = registerPhoneNumberForm.find('#dataType').val();
      }
    }

    var path;

    switch (type) {
      case 'advert':
        path = isAuto ? 'car/contact' : 'listings/contact';
        model = 'App\\Models\\Advert';
        break;
      case 'advertiser':
        path = 'advertiser/contact';
        model = 'App\\Models\\Advertiser';
        break;
      case 'store':
        path = 'store/contact';
        model = 'App\\Models\\Advertiser';
        break;
      case 'advert-whitelabel':
        path = isAuto ? 'a/car/contact' : 'a/listings/contact';
        model = 'App\\Models\\Advert';
        break;
      default:
        path = null;
        model = null;
    }

    if (path == null) {
      switch ($modal.attr('id')) {
        case 'login-modal':
          $('#login-options-modal').modal('hide');
          break;
        case 'registration-modal':
          $('#login-modal').modal('hide');
          break;
        default:
          break;
      }
    } else {
      var url = app_url + '/' + path;

      $.ajax({
        type: 'POST',
        url: url,
        data: {
          id: id,
          intent: intent,
        },
      })
        .done(function (response) {
          if (
            response.data != undefined &&
            response.data.code === 200 &&
            typeof response === 'object'
          ) {
            advert = response.data.advert;
            switch ($modal.attr('id')) {
              case 'contact-seller':
                var $contactForm = $('#contact-seller-form-modal');
                if (advert.is_advertiser_store_front) {
                  $contactForm.attr('action', advert.message_route);
                } else {
                  $contactForm.attr('action', advert.route + '/message');
                }

                $contactForm.find('#advert_id').attr('value', advert.id);
                $modal
                  .find('#map .modal-title')
                  .html(jsTrans['map_to'] + advert.seller_name);
                $modal.find('#main .modal-title').empty();
                if (advert.storefront && !advert.payable) {
                  if (advert.priority) {
                    $modal
                      .find('#main .modal-title')
                      .html(
                        "<div class='center' style='padding:5px;'>" +
                          advert.store_name +
                          "</div><a href='" +
                          advert.url +
                          "'><img src='" +
                          advert.logo +
                          "' alt='" +
                          advert.store_name +
                          " logo' class='img-responsive center'/></a>"
                      );
                  } else {
                    $modal
                      .find('#main .modal-title')
                      .html(
                        "<a href='" +
                          advert.url +
                          "'>" +
                          advert.store_name +
                          '</a>'
                      );
                  }
                } else {
                  // $modal.find('#main .modal-title').html(advert.store_name);
                }

                $mainDetails.empty();

                if (intent == 'email') {
                  $('.contact_form').show();
                  $('.accept-terms-submit').show();
                  // Very important for email lead attribution
                  $contactForm.find('#email_lead').attr('value', 1);
                } else {
                  // Very important for email lead attribution
                  $contactForm.find('#email_lead').attr('value', 0);
                  $('.contact_form').hide();
                  $('.accept-terms-submit').hide();
                }
                $('.g-recaptcha').hide();
                $('.g-recaptcha-lable').hide();

                if (advert.show_safety_snippet) {
                  $('.show-safety-tips').show();
                } else {
                  $('.show-safety-tips').hide();
                  $('.modal-footer-buttons').removeClass('modal-close-btn');
                }
                if (advert.payable) {
                  $('.modal').css({
                    'min-height': 'calc(100vh - 210px)',
                    'overflow-y': 'auto',
                  });
                }

                var advetiser_info =
                  '<div class="row modal-options"><div class="col-md-4 col-sm-4 pull-left phone-popup modal-options-title">Member Since: </div><div class="col-md-8 col-sm-8">' +
                  advert.since +
                  '</div></div>';
                advetiser_info +=
                  '<div class="row modal-options"><div class="col-md-4 col-sm-4 pull-left phone-popup modal-options-title">Number of Active Ads: </div><div class="col-md-8 col-sm-8">' +
                  advert.numberOfAds +
                  '</div></div>';
                if (advert.is_verified) {
                  advetiser_info +=
                    '<div class="row modal-options"><div class="col-md-4 col-sm-4 pull-left phone-popup modal-options-title">Contact Name: </div><div class="col-md-8 col-sm-8">' +
                    advert.contact_name +
                    '</div></div>';
                }
                $mainDetails.append(advetiser_info);

                if (
                  advert.mobile_number &&
                  !advert.privacy &&
                  intent === 'call'
                ) {
                  var mobile_number =
                    '<div class="row modal-options"><div class="col-md-4  phone-popup modal-options-title"><strong>' +
                    jsTrans['verified_number'] +
                    ' ' +
                    jsTrans['contact_phone'] +
                    ' Number:</strong></div><div class="col-md-8"><div class="mobile-number"><strong><a href="tel:' +
                    advert.mobile_number +
                    '">' +
                    advert.mobile_number +
                    '</a>';
                  mobile_number += '</span></span>';
                  if (advert.is_verified) {
                    mobile_number +=
                      '<span class="mobile-number verified_number"> Verified <i class="green fa fa-check"></i> <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="This mobile number has been verified after we sent the number a unique code sent by SMS"></i></span>';
                    mobile_number +=
                      '<span title="Seller accepts WhatsApp" style="font-weight:bold; padding-left: 5px;">WhatsApp <i class="fa fa-whatsapp"></i><span class="green fa fa-check"></span></span>';
                  }
                  mobile_number += '</div></div></div>';

                  $mainDetails.append(mobile_number);
                }

                if (advert.accepts_whatsapp && intent === 'whatsapp') {
                  var mobile_number =
                    '<div class="row modal-options"><div class="col-md-4 phone-popup modal-options-title"><strong> WhatsApp Seller:</strong></div><div class="col-md-8"><div class="mobile-number"><strong><a target="_blank" href="' +
                    advert.whatsapp_link +
                    '">' +
                    '<strong style="margin-right: 5px; font-size: 14px;">Click here to start chatting on WhatsApp.</strong><i class="fa fa-whatsapp whatsapp">' +
                    '</a>';
                  mobile_number += '</span></span>';
                  mobile_number += '</div></div></div>';

                  $mainDetails.append(mobile_number);
                }

                if (advert.landline && !advert.privacy && intent === 'call') {
                  $mainDetails.append(
                    '<div class="row modal-options"><div class="col-md-4 pull-left phone-popup modal-options-title">Other Phone ' +
                      jsTrans['numbers'] +
                      ':</div><div class="col-md-8"><strong><a href="tel:' +
                      advert.landline +
                      '">' +
                      advert.landline +
                      '</a></strong></div></div>'
                  );
                }

                if (
                  (advert.landline || advert.mobile_number) &&
                  intent === 'call'
                ) {
                  recordEvent(model, advert, 'viewed number');
                }

                if (intent == 'whatsapp') {
                  recordEvent(model, advert, 'chat whatsapp');
                }

                if (intent == 'address') {
                  recordEvent(model, advert, 'address');
                }

                if (advert.address && !advert.privacy && intent === 'call') {
                  let address_info =
                    '<div class="address  row modal-options"><div class="col-md-4 col-sm-2 pull-left  phone-popup modal-options-title">' +
                    jsTrans['address'] +
                    ':</div><div class="col-md-8 col-sm-10"><addr>';
                  if (advert.street_address) {
                    address_info += advert.street_address + ', ';
                  }
                  address_info += advert.address + '</addr></div></div>';

                  $mainDetails.append(address_info);
                }

                if (advert.business_hours && intent !== 'whatsapp') {
                  $mainDetails.append(
                    '<div class="business_hours row modal-options"><div class="col-md-4 col-sm-2 pull-left  phone-popup modal-options-title">' +
                      jsTrans['business_hours'] +
                      ':</div><div class="col-md-8 col-sm-10">' +
                      strip_tags(advert.business_hours) +
                      '</div></div>'
                  );
                }
                if (advert.delivery_options) {
                  $mainDetails.append(
                    '<div class="business_hours row modal-options"><div class="col-md-4 col-sm-2 pull-left  phone-popup modal-options-title">Delivery Options:</div><div class="col-md-8 col-sm-10">' +
                      advert.delivery_options +
                      '</div></div>'
                  );
                }
                if (advert.payment_options) {
                  $mainDetails.append(
                    '<div class="business_hours row modal-options"><div class="col-md-4 col-sm-2 pull-left  phone-popup modal-options-title">Payment Options:</div><div class="col-md-8 col-sm-10">' +
                      advert.payment_options +
                      '</div></div>'
                  );
                }

                var buttons = '';
                if (advert.url_livechat) {
                  buttons +=
                    '<button type="button" class="btn btn-chat btn-xs btn-advert" ' +
                    'data-url="' +
                    advert.url_livechat +
                    '" ' +
                    'title="' +
                    jsTrans['live_chat'] +
                    '"><i class="fa fa-comments-o"></i> ' +
                    jsTrans['live_chat'] +
                    '</button>';
                }

                if (advert.address) {
                  // buttons += '<button type="button" class="btn btn-map btn-modal btn-default"><i class="fa fa-map-marker"></i> ' + jsTrans['show_on_map'] + '</button>';
                  if (
                    advert.address &&
                    !advert.privacy &&
                    intent === 'address'
                  ) {
                    let address_info =
                      '<div class="address  row modal-options"><div class="col-md-4 col-sm-2 pull-left  phone-popup modal-options-title">' +
                      jsTrans['address'] +
                      ':</div><div class="col-md-8 col-sm-10"><addr>';
                    if (advert.street_address) {
                      address_info += advert.street_address + ', ';
                    }
                    address_info += advert.address;
                    address_info += '</addr></div></div>';

                    address_info +=
                      '<br /><a href="#!" onclick="showMap(\'' +
                      advert.street_address +
                      ', ' +
                      advert.address +
                      '\')">GET DIRECTIONS</a>';

                    $mainDetails.append(address_info);
                  }
                }
                if (buttons) {
                  $mainDetails.append(
                    '<div class="action-buttons row"><div class="col-md-8">' +
                      buttons +
                      '</div></div>'
                  );
                }

                $mainDetails.find('.btn-map').on('click', function () {
                  $modal.find('#main').hide();

                  $modal.find('#map').show();
                  loadAdvertMap(
                    advert.latitude,
                    advert.longitude,
                    advert.address,
                    $modal
                  );

                  $modal.find('#map .btn-back').one('click', function () {
                    $modal.find('#map').hide();
                    $modal.find('#main').show();
                  });
                });

                /** Remove the country prefix from the mobile_number if we have one */
                var prefix = null;

                $(
                  ".modal-body .form select[name='mobile_number_country'] option:selected"
                ).each(function () {
                  prefix = $(this).text();
                });

                var mobile_number = $(
                  ".modal-body .form input[name='mobile_number']"
                ).val();
                $(".modal-body .form input[name='mobile_number']").val(
                  mobile_number.replace(prefix, '')
                );

                var advert_price = advert.price_amount
                  ? 'USD ' + advert.price_amount
                  : '';
                var message =
                  jsTrans['hello'] +
                  ' ' +
                  strip_tags(advert.title) +
                  ' : ' +
                  advert_price +
                  ' advert on ' +
                  advert.route;

                if (advert.is_advertiser_store_front) {
                  if (intent == 'email') {
                    $('.modal-body .form textarea[name="message"]').html('');
                  } else if (intent == 'call') {
                    $('.modal-body .form textarea[name="message"]').html(
                      advert.store_route
                    );
                  } else {
                    $('.modal-body .form textarea[name="message"]').html(
                      jsTrans['hello_store'] + advert.store_route
                    );
                  }
                } else {
                  $('.modal-body .form textarea[name="message"]').html(message);
                }

                if (
                  (intent == 'whatsapp' || intent == 'call') &&
                  !advert.datingCategory
                ) {
                  var postData = $contactForm.serializeArray();
                  var url = $contactForm.attr('action');

                  $.ajax({
                    url: url,
                    type: 'POST',
                    data: postData,
                  });
                }

                $('.modal-register-phonenumber-title').empty();
                var $registerPhoneNumberForm = $('#register-phonenumber-form');
                if ($registerPhoneNumberForm != undefined) {
                  var currentUrl = $(location).attr('href');
                  $registerPhoneNumberForm
                    .find('#advert_id')
                    .attr('value', advert.id);
                  $registerPhoneNumberForm
                    .find('#intent')
                    .attr('value', intent);
                  $registerPhoneNumberForm
                    .find('#category_id')
                    .attr('value', category.leaf);
                  $registerPhoneNumberForm
                    .find('#dataType')
                    .attr('value', type);
                }

                break;
              case 'report-advert':
                $('form', this).attr('action', advert.route + '/report');
                recordEvent(model, advert, 'report');
                advert = null;
                break;
              case 'email-advert':
                $('form', this).attr('action', advert.route + '/email');
                advert = null;
                break;
              case 'pay-per-view':
                $('.modal-pay-per-view-title').empty();
                var modalPayPerViewTitle =
                  'Pay <b>' +
                  category.points +
                  " Classifieds Points </b> for this advertiser's contact information.";
                if (advert.loggedin) {
                  modalPayPerViewTitle =
                    modalPayPerViewTitle +
                    '<br> Current balance: <b>' +
                    advert.auth_user_wallet_points +
                    '  Classifieds Points </b>.';
                }
                $('.modal-pay-per-view-title').append(modalPayPerViewTitle);
                var $payPerViewForm = $('#pay-per-view-form');

                if (advert.loggedin) {
                  if (
                    advert.auth_user_wallet_points === 0 &&
                    $payPerViewForm.find('#pay-per-view-form-submit').length
                  ) {
                    $payPerViewForm
                      .find('#pay-per-view-form-submit')
                      .text('TOPUP WALLET');
                  }
                }

                var redirect =
                  $payPerViewForm.find('.btn-topup').attr('href') +
                  '?redirect=' +
                  advert.route;
                var currentUrl = $(location).attr('href');
                $payPerViewForm.find('#pay_advert_id').attr('value', advert.id);
                $payPerViewForm.find('#intent').attr('value', intent);
                $payPerViewForm
                  .find('#category_id')
                  .attr('value', category.leaf);
                $payPerViewForm
                  .find('#category_price')
                  .attr('value', category.price);
                $payPerViewForm
                  .find('#category_points')
                  .attr('value', category.points);
                $payPerViewForm
                  .find('#category_level_1')
                  .attr('value', category.level_1);
                $payPerViewForm
                  .find('#formAction')
                  .attr('value', advert.route + '/wallet');
                $payPerViewForm.find('#url').attr('value', advert.route);
                $payPerViewForm.find('#currentUrl').attr('value', currentUrl);
                $payPerViewForm
                  .find('#pay-per-view-form-submit')
                  .attr('data-id', advert.id);
                $payPerViewForm
                  .find('#pay-per-view-form-submit')
                  .attr('data-type', 'advert');
                $payPerViewForm.find('.btn-topup').attr('href', redirect);
                break;
              case 'login-modal':
                $('#login-options-modal').modal('hide');
                break;
              case 'register-phonenumber':
                $('.modal-register-phonenumber-title').empty();
                var $registerPhoneNumberForm = $('#register-phonenumber-form');
                var currentUrl = $(location).attr('href');
                $registerPhoneNumberForm
                  .find('#advert_id')
                  .attr('value', advert.id);
                $registerPhoneNumberForm.find('#intent').attr('value', intent);
                $registerPhoneNumberForm
                  .find('#category_id')
                  .attr('value', category.leaf);
                $registerPhoneNumberForm.find('#dataType').attr('value', type);
                break;
              case 'registration-modal':
                $('#login-modal').modal('hide');
                break;
              case 'you_tube_video_link_modal':
                $modal.find('#main .modal-title').empty();
                if (advert.storefront && !advert.payable) {
                  if (advert.priority) {
                    $modal
                      .find('#main .modal-title')
                      .html(
                        "<a href='" +
                          advert.url +
                          "' class='center'>" +
                          advert.store_name +
                          "</a><a href='" +
                          advert.url +
                          "'><img src='" +
                          advert.logo +
                          "' alt='" +
                          advert.store_name +
                          " logo' class='img-responsive center'/></a>"
                      );
                  } else {
                    $modal
                      .find('#main .modal-title')
                      .html(
                        "<a href='" +
                          advert.url +
                          "'>" +
                          advert.store_name +
                          '</a>'
                      );
                  }
                } else {
                  $modal.find('#main .modal-title').html(advert.store_name);
                }
                break;
              default:
                break;
            }
            $modal.removeData();
          } else if (
            response.data != undefined &&
            response.data.code === 302 &&
            typeof response === 'object'
          ) {
            $('.modal-pay-per-view-title').empty();
            $('.modal-pay-per-view-title').append(
              '<div class="alert alert-warning alert-dismissable"> <b>' +
                '<p>Your session has expired due to inactivity, we will redirect you now.</p>' +
                '</b></div>'
            );
            window.location.replace(response.data.redirect);
            $modal.removeData();
          } else if (
            response.data != undefined &&
            response.data.code === 401 &&
            typeof response === 'object'
          ) {
            setTimeout(function () {
              $('#contact-seller').modal('hide');
              $('#register-phonenumber').modal('show');
            }, 500);
          }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error(
            'Request failed:',
            textStatus,
            errorThrown,
            jqXHR.responseText
          );
        });
    }
  });

  $('.buyer-bar__whatsapp').on('click', function (e) {
    var $div = $(this);

    var id = $div.closest('.listing, .listing-related').data('id');
    var type = $div.closest('.listing, .listing-related').data('type');
    var intent = $div.data('intent');

    // This removes the selected data from jquery cache, we always want fresh data
    $div.removeData();

    whatsappHref = $div.data('href');

    if (whatsappHref.startsWith('https://rply.link')) {
      const url = new URL(whatsappHref);
      url.searchParams.set('fingerprint', userIdentifier);
      whatsappHref = url.toString();
    }

    window.open(whatsappHref, '_blank');

    var url;
    var mode;

    switch (type) {
      case 'advert':
        url = isAuto
          ? `${location.origin}/car/contact`
          : `${location.origin}/listings/contact`;
        mode = 'App\\Models\\Advert';
        break;
      case 'advertiser':
        url = `${location.origin}/advertiser/contact`;
        mode = 'App\\Models\\Advertiser';
        break;
      case 'store':
        url = `${location.origin}/store/contact`;
        mode = 'App\\Models\\Advertiser';
        break;
      default:
        url = null;
        mode = null;
    }

    if (url !== null) {
      $.ajax({
        type: 'POST',
        url: url,
        data: {
          id: id,
        },
      }).done(function (response) {
        if (
          response.data != undefined &&
          response.data.code === 200 &&
          typeof response === 'object'
        ) {
          advert = response.data.advert;

          if (intent == 'whatsapp') {
            recordEvent(mode, advert, 'chat whatsapp');
          }
        } else if (
          response.data != undefined &&
          response.data.code === 302 &&
          typeof response === 'object'
        ) {
          $('.alerts').empty();
          $('.alerts').append(
            '<div class="alert alert-warning alert-dismissable"> <b>' +
              '<p>Your session has expired due to inactivity, we will redirect you now.</p>' +
              '</b></div>'
          );
        }
      });
    }
  });

  function loadAdvertMap(latitude, longitude, address, $modal) {
    address = address + ' ' + jsTrans['country'];

    if (
      latitude != null &&
      longitude != null &&
      latitude != 0.0 &&
      longitude != 0.0 &&
      latitude != default_map_lat &&
      longitude != default_map_long
    ) {
      map = new google.maps.Map($mapCanvas.get(0), {
        zoom: 14,
      });
      var center = new google.maps.LatLng(
        parseFloat(latitude),
        parseFloat(longitude)
      );
      map.setCenter(center);
      var marker = new google.maps.Marker({
        map: map,
        position: {
          lat: parseFloat(latitude),
          lng: parseFloat(longitude),
        },
      });

      $modal
        .find('.get_directions_link')
        .attr(
          'href',
          'https://maps.google.com?saddr=Current+Location&daddr=' +
            latitude +
            ',' +
            longitude
        );
    } else if (address == jsTrans['country'] + ' ' + jsTrans['country']) {
      map = new google.maps.Map($mapCanvas.get(0), {
        zoom: default_map_zoom,
      });
      var center = new google.maps.LatLng(
        parseFloat(default_map_lat),
        parseFloat(default_map_long)
      );
      map.setCenter(center);
    } else {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            map = new google.maps.Map($mapCanvas.get(0), {
              zoom: 14,
            });
            map.setCenter(results[0].geometry.location);
            var marker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location,
            });
          } else {
            map = new google.maps.Map($mapCanvas.get(0), {
              zoom: default_map_zoom,
            });
            var center = new google.maps.LatLng(
              parseFloat(default_map_lat),
              parseFloat(default_map_long)
            );
            map.setCenter(center);
          }
        }
      );
    }
  }

  $('.gallery').each(function () {
    var $gallery = $(this),
      $carousel = $gallery.find('.carousel').carousel({
        interval: false,
      });

    function createItem(func) {
      var $active = $carousel.find('.carousel-item.active'),
        current = $active.data('index'),
        index = func(current, $carousel.data('images').length);

      if ($carousel.find('.carousel-item[data-index="' + index + '"]').length) {
        return;
      }

      var url = $carousel.data('images')[index],
        html =
          '<div class="carousel-item" data-index="' +
          index +
          '">' +
          url +
          '</div>';

      console.debug('Creating item ' + index);

      if (index == 0) {
        $carousel.find('.carousel-inner').prepend(html);
      } else {
        for (var x = index - 1; x >= 0; x--) {
          var $item = $carousel.find('.carousel-item[data-index="' + x + '"]');

          if ($item.length) {
            console.debug(
              'Adding ' +
                index +
                ' after ' +
                $item.get(0).outerHTML +
                ' html: ' +
                html
            );
            $item.after(html);
            break;
          }
        }
      }

      return $carousel.find('.carousel-item[data-index="' + index + '"]');
    }

    //var Carousel = $.fn.carousel.Constructor;

    $carousel.find('.carousel-control-next').click(function () {
      var created = createItem(function (current, length) {
        var index = (current + 1) % length;
        return index;
      });

      // return $carousel.carousel('next');
    });

    $carousel.find('.carousel-control-prev').click(function () {
      var created = createItem(function (current, length) {
        var index = (current + length - 1) % length;
        return index;
      });

      // return $carousel.carousel('prev');
    });

    var ytdPlayer;
    $carousel.on('slide.bs.carousel', function (e) {
      var slideIndex = $(e.relatedTarget).index();
      if (_ytdVideoIndex && _ytdVideoIndex == slideIndex) {
        if (!ytdPlayer && typeof YT !== 'undefined') {
          ytdPlayer = new YT.Player('ytd_video', {
            events: {
              onStateChange: onPlayerStateChange,
            },
          });
        }
      } else {
        if (ytdPlayer && ytdPlayer.pauseVideo) {
          ytdPlayer.pauseVideo();
          $('.carousel').carousel('cycle');
          console.log('video paused, and carousel is cycling');
        }
      }
    });

    $carousel.on('slid.bs.carousel', function (e) {
      var index = $(e.relatedTarget).data('index');
      $gallery
        .find('.thumbnails')
        .find('.active')
        .removeClass('active')
        .end()
        .find('[data-index="' + index + '"]')
        .addClass('active');
    });

    $gallery.find('.thumbnails .image').click(function (e) {
      var index = parseInt($(this).data('index'));

      var $active = $carousel.find('.carousel-item.active'),
        current = $active.data('index');

      if (current < index) {
        /** Any items in-between must be created as well */
        for (var x = current + 1; x <= index; x++) {
          createItem(function (current, length) {
            return x;
          });
        }
      }

      $carousel.carousel(index);
    });
  });

  $('.seller-bar .workflow-action').click(function (e) {
    e.preventDefault();

    var text = $(this).text().trim();

    if (
      text == 'Publish' ||
      text == 'Unpublish' ||
      text == 'Renew' ||
      confirm('Are you sure?')
    ) {
      var pleaseWaitDiv = $('#pleaseWaitDialog');
      pleaseWaitDiv.modal();
      $.ajax({
        method: 'POST',
        url: $(this).data('href'),
        success: function (data) {
          pleaseWaitDiv.modal('hide');
          window.location.reload(true);
        },
        error: function (data) {
          pleaseWaitDiv.modal('hide');
          alert(data.responseJSON.message);
        },
      });
      var advert = $advert.data('advert');

      function addToCart(user, done) {
        $.ajax({
          method: 'GET',
          url: url,
          data: {
            advert_id: advert.id,
          },
        })
          .done(function (response) {
            /** Alter the cart count */
            $('.cart-count').html(response.data.count);

            $('.alerts-' + advert.id).append(
              '<div class="alert alert-info alert-dismissable">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button> <b>' +
                jsTrans['add_to_cart'] +
                '</b></div>'
            );
          })
          .fail();
      }

      var url = $button.data('url');
      addToCart(url);
    }
  });

  $('.seller-bar .btn-delete').click(function (e) {
    e.preventDefault();

    if (confirm('Are you sure?')) {
      var $pleaseWaitDiv = $('#pleaseWaitDialog');
      $pleaseWaitDiv.modal();
      $.ajax({
        method: 'POST',
        data: {
          _method: 'DELETE',
        },
        url: $(this).data('href'),
      }).done(function (response) {
        $pleaseWaitDiv.modal('hide');
        window.location = response.data.url;
      });
    }
  });

  $('.favourite').click(function (e) {
    e.preventDefault();

    var $button = $(this);
    var $advert;

    if ($button.data('target')) {
      $advert = $($button.data('target'));
    } else {
      $advert = $button.closest('.listing');
    }
    var advertID = $advert.data('id');

    const category = $advert.data('category');

    const advertCategoryDetails = {
      category_title: category.title || '',
      category_id: category.leaf || '',
    };

    function toggleFavourite(advert, url, done) {
      if ($button.data('exists')) {
        $.ajax({
          method: 'POST',
          url: url,
          data: {
            _method: 'DELETE',
          },
        })
          .done(function (response) {
            if (response.data?.collection_url == window.location.href) {
              /** If we are on the favourites index page, remove this advert dynamically */
              $advert.remove();
            } else {
              $button
                .data({
                  url: response.data?.collection_url,
                  exists: false,
                })
                .attr('title', 'Favourite advert ' + advertID)
                .find('.fa')
                .removeClass('fa-heart')
                .addClass('fa-heart-o');
            }

            /** Alter the favourite count */
            $('#favourite-count')
              .attr('title', 'Favourites: ' + response.data.count)
              .find('.badge')
              .html(response.data.count);

            if (typeof done !== 'undefined') {
              done();
            }
          })
          .fail(console.log);
      } else {
        $.ajax({
          method: 'POST',
          url: url,
          data: {
            advert_id: advertID,
          },
        })
          .done(function (response) {
            recordEvent('App\\Models\\Advert', advert, 'favourited');
            $button
              .data({
                url: response.data?.url,
                exists: true,
              })
              .attr('title', jsTrans['unfavourite_advert'] + advertID)
              .find('.fa')
              .removeClass('fa-heart-o')
              .addClass('fa-heart');

            /** Alter the favourite count */
            $('#favourite-count')
              .attr('title', jsTrans['favourites'] + response.data.count)
              .find('.badge')
              .html(response.data.count);

            if (typeof done !== 'undefined') {
              done();
            }
          })
          .fail(console.log);
      }
    }

    var url = $button.data('url');

    if (url) {
      toggleFavourite(advertCategoryDetails, url, function () {
        window.location.reload(true);
      });
    } else {
      localStorage.setItem(
        'advert_favourate',
        JSON.stringify({ advertID, category })
      );

      console.log(
        'Setting an advert flag in local storage',
        localStorage.getItem('advert_favourate')
      );

      window.location.replace('auth/login');
    }
  });

  (function checkIsFavourating() {
    var isLoggedIn = $('body').hasClass('logged-in');
    var advert = localStorage.getItem('advert_favourate');

    if (isLoggedIn && advert) {
      var url = 'https://' + window.location.hostname + '/user/';
      var userId = $('body').data('userid');
      if (advert) {
        const { advertID } = JSON.parse(advert);

        url = url + `${userId}/favourite`;

        console.log('Url for favourite : ', url);

        $.ajax({
          method: 'POST',
          url: url,
          data: {
            advert_id: advertID,
          },
        })
          .done(function (response) {
            console.log('Response from the server'.response);
            recordEvent('App\\Models\\Advert', advert, 'favourited');
            console.log('waiting reload now');
            localStorage.removeItem('advert_favourate');
            $('.alerts')
              .html(
                '<div class="alert alert-success alert-dismissable"> Favourite added successfully<b/></div>'
              )
              .fadeIn('slow');
            window.location.reload(true);
          })
          .fail(console.log);
      }
    }
  })();

  function clearModal(modal) {
    modal.find('#main .modal-title').empty();
    modal.find('#main .details').empty();
    modal.find('.modal-pay-per-view-title').empty();
    modal.find('.modal-body .form textarea[name="message"]').html('');
    $('.contact_form').hide();
    $('.accept-terms-submit').hide();
    $('.modal-alerts').empty();
  }

  $('#contact-seller, #email-advert', '#pay-per-view').on(
    'hide.bs.modal',
    function () {
      advert = null;
      model = null;
      $(this).find('#map').hide();
      $(this).find('#main').show();
      clearModal($(this));
    }
  );

  $('#select-order').change(function () {
    $('#order').val($(this).val());
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);

    params.set('order', $(this).val());

    window.location.href = `${location.pathname}?${params}`;
  });

  $('.btn-show-more').click(function () {
    var show = $(this).html() == jsTrans['show_more'];
    if (show) {
      $(this).html(jsTrans['show_less']);
    } else {
      $(this).html(jsTrans['show_more']);
    }

    $(this)
      .prev()
      .find('li')
      .each(function (index, item) {
        if (index >= filtersLimit) {
          if (show) {
            $(item).removeClass('hidden');
          } else {
            $(item).addClass('hidden');
          }
        }
      });
  });

  $('.addToCart').click(function (e) {
    e.preventDefault();

    var $button = $(this);
    var $advert;

    if ($button.data('target')) {
      $advert = $($button.data('target'));
    } else {
      $advert = $button.closest('.listing');
    }
    var advert = $advert.data('advert');

    function addToCart(user, done) {
      $.ajax({
        method: 'GET',
        url: url,
        data: {
          advert_id: advert.id,
        },
      })
        .done(function (response) {
          /** Alter the cart count */
          $('.cart-count').html(response.data.count);

          $('.alerts-' + advert.id).append(
            '<div class="alert alert-info alert-dismissable">' +
              '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
              '<span aria-hidden="true">&times;</span> <b>' +
              '</button>' +
              jsTrans['add_to_cart'] +
              '</b></div>'
          );
        })
        .fail(console.error);
    }

    var url = $button.data('url');
    addToCart(url);
  });

  function recordEvent(model, advert, eventName) {
    if (advert === undefined) {
      return;
    }

    var actionThings = {
      'viewed number': 'listing-phone',
      'chat whatsapp': 'listing-whatsapp',
      'sent message': 'listing-message',
      'sent email': 'listing-email',
      'raq email': 'raq-email',
      favourited: 'listing-favourited',
      address: 'showed-address',
      report: 'reported-listing',
    };

    var dbActionThings = {
      'viewed number': 'viewed number',
      'chat whatsapp': 'chat whatsapp',
      'sent message': 'sent message',
      'sent email': 'sent email',
      'raq email': 'raq email',
      favourited: 'favourited',
      address: 'show address',
      report: 'reported',
    };

    // We do not want to duplicate leads here
    if (!!localStorage.getItem('auto-clicked-button')) {
      return localStorage.removeItem('auto-clicked-button');
    }

    // Important: please do not remove labels if not asked to: important for metrics and leads analytics

    const categoryName = advert.category_title;
    const categoryID = advert.category_id;
    const context = window.getContextFromRoute();
    const eventAction = actionThings[eventName];
    const dbEventAction = dbActionThings[eventName];
    const eventLabel = `${categoryName} - ${categoryID}`;
    const eventCategory = 'lead';
    const dbEventCategory = 'leads';
    const listingID = advert.id;

    const notLead = ['favourited', 'address', 'report'];

    if (notLead.indexOf(eventName) === -1) {
      dataLayer.push({
        event: `${eventAction}-${eventCategory}`,
        listing_category_name: categoryName,
        listing_category_id: categoryID,
        listing_id: listingID,
        page_type: context,
        page_url: window.location.href,
      });

      window.sendEvent(
        model,
        listingID,
        categoryID,
        dbEventCategory,
        dbEventAction,
        eventLabel,
        null,
        window.location.href
      );
    } else {
      dataLayer.push({
        event: `${eventAction}`,
        listing_category_name: categoryName,
        listing_category_id: categoryID,
        listing_id: listingID,
        page_type: context,
        page_url: window.location.href,
      });

      window.sendEvent(
        model,
        listingID,
        categoryID,
        dbEventCategory,
        dbEventAction,
        eventLabel,
        null,
        window.location.href
      );
    }
  }

  function recordGAEvent(model, advert, eventName) {
    if (advert === undefined) {
      return;
    }

    var actionThings = {
      'viewed number': 'listing-phone',
      'chat whatsapp': 'listing-whatsapp',
      'sent message': 'listing-message',
      'sent email': 'listing-email',
      'raq email': 'raq-email',
      favourited: 'listing-favourited',
      address: 'showed-address',
      report: 'reported-listing',
    };

    var dbActionThings = {
      'viewed number': 'viewed number',
      'chat whatsapp': 'chat whatsapp',
      'sent message': 'sent message',
      'sent email': 'sent email',
      'raq email': 'raq email',
      favourited: 'favourited',
      address: 'show address',
      report: 'reported',
    };

    // We do not want to duplicate leads here
    if (!!localStorage.getItem('auto-clicked-button')) {
      return localStorage.removeItem('auto-clicked-button');
    }

    // Important: please do not remove labels if not asked to: important for metrics and leads analytics

    const categoryName = advert.category_title;
    const categoryID = advert.category_id;
    const context = window.getContextFromRoute();
    const eventAction = actionThings[eventName];
    const eventCategory = 'lead';
    const listingID = advert.id;

    const notLead = ['favourited', 'address', 'report'];

    if (notLead.indexOf(eventName) === -1) {
      dataLayer.push({
        event: `${eventAction}-${eventCategory}`,
        listing_category_name: categoryName,
        listing_category_id: categoryID,
        listing_id: listingID,
        page_type: context,
        page_url: window.location.href,
      });
    } else {
      dataLayer.push({
        event: `${eventAction}`,
        listing_category_name: categoryName,
        listing_category_id: categoryID,
        listing_id: listingID,
        page_type: context,
        page_url: window.location.href,
      });
    }
  }

  $('#contact-seller').on('submit', function (e) {
    var contactForm = $('form', this);
    // Prevent double submission
    contactForm.find('#send-email').attr('disabled', true);
    recordEvent(model, advert, 'sent email');
  });

  $('#quoteForm').on('submit', function (e) {
    var quoteForm = $(this);

    var submitBtn = $(quoteForm.find('#submitBtn'));

    // Prevent double submission
    submitBtn.attr('disabled', true);
    submitBtn.html(
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Submitting...'
    );

    var model = 'App\\Models\\Advert';

    var advert = {
      category_title: quoteForm.find("input[name='category_title']").val(),
      category_id: quoteForm.find("input[name='category_id']").val(),
    };

    recordGAEvent(model, advert, 'raq email');
  });
});

jQuery(document).ajaxComplete(function () {
  loadButtonModalClick();
});

showMap = function (address) {
  var geocoder = new google.maps.Geocoder();
  var latlng = new google.maps.LatLng(19.0154, -29.1549); //zim coordinates
  var mapOptions = {
    zoom: 15,
    center: latlng,
  };
  var map = new google.maps.Map(
    document.getElementById('map-canvas'),
    mapOptions
  );

  geocoder.geocode({ address: address }, function (results, status) {
    if (status == 'OK') {
      map.panTo(results[0].geometry.location);
      var marker = new google.maps.Marker({
        map: map,
        position: results[0].geometry.location,
      });
    } else {
      console.log(
        'Geocode was not successful for the following reason: ' + status
      );
    }
  });

  $('#map_modal').modal('show');
};
